interface ProdutoListavel {
  id: string
  codigo: string
  descricao: string
}

export interface ListaDaTabela<T> {
  naTabela: T[]
  foraDaTabela: T[]
}

// O que a tela "Tabela: X" deve listar, em DOIS grupos rotulados.
//
// Antes era uma lista so, com o catalogo inteiro da fornecedora: quem nao tinha
// preco nesta tabela aparecia junto, com o campo em branco, indistinguivel de
// quem e da tabela. O titulo prometia a tabela e a lista entregava outra coisa.
//
// Separar (em vez de esconder os de fora) preserva o outro trabalho desta tela:
// dar preco em lote e como se popula uma tabela nova -- numa tabela recem
// criada, esconder quem nao tem preco deixaria a tela vazia e obrigaria a
// buscar produto por produto.
//
// Sem corte: o `.limit(100)` antigo, numa ordem sem significado, podia esconder
// produto que ESTA na tabela e deixa-lo sem como ter o preco corrigido.
// Achado 2 do smoke de 2026-07-27.
export function produtosParaEditarPreco<T extends ProdutoListavel>(
  produtos: T[],
  comPrecoNaTabela: Set<string>,
  busca: string,
): ListaDaTabela<T> {
  const termo = busca.trim().toLowerCase()
  const casa = (p: T) =>
    termo === '' ||
    p.codigo.toLowerCase().includes(termo) ||
    p.descricao.toLowerCase().includes(termo)

  const porDescricao = (a: T, b: T) => a.descricao.localeCompare(b.descricao, 'pt-BR')
  const encontrados = produtos.filter(casa)
  return {
    naTabela: encontrados.filter((p) => comPrecoNaTabela.has(p.id)).sort(porDescricao),
    foraDaTabela: encontrados.filter((p) => !comPrecoNaTabela.has(p.id)).sort(porDescricao),
  }
}
